export function simpleSort(a, b) {
  var _a, _b;

  a = (_a = a) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase();
  b = (_b = b) === null || _b === void 0 ? void 0 : _b.toString().toLowerCase();
  return a > b ? 1 : a < b ? -1 : 0;
}